import { DateFilterModel } from '@/core/interfaces/data-filter'
import { FC, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { saveAs } from 'file-saver'
import useBackendError from '@/hooks/useBackendError'
import { cn } from '@bem-react/classname'
import { Filter } from '@/components/Filter'
import { Button } from '@/components/Button'
import { TRANSACTIONS_FILE_TYPE } from '../../constants'
import './Transactions.scss'
import { Checkbox } from '@/components/form/Checkbox'
import LicensesService from '../../LicensesService'

const cnTransactions = cn('Transactions')

const Transactions: FC = () => {
  const [isLoadTransactions, setLoadTransactions] = useState<boolean>(false)
  const [date, setDate] = useState<DateFilterModel>({} as DateFilterModel)
  const [isIncludeExpired, setIsIncludeExpired] = useState<boolean>(false)
  const [isIncludeDeleted, setIsIncludeDeleted] = useState<boolean>(false)

  const { t } = useTranslation()
  const [setBackendError] = useBackendError()

  const handleDownloadTransactions = useCallback(async (): Promise<void> => {
    setLoadTransactions(true)

    try {
      const res = await LicensesService.getTransactions({
        ...date,
        isIncludeDeleted,
        isIncludeExpired,
      })

      const newBlob = new Blob([res], {
        type: TRANSACTIONS_FILE_TYPE,
      })

      saveAs(newBlob, t('Transactions'))
      setLoadTransactions(false)
    } catch (errors) {
      setBackendError(errors)
    } finally {
      setLoadTransactions(false)
    }
  }, [date, isIncludeDeleted, isIncludeExpired])

  const handleIsIncludeExpiredChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    setIsIncludeExpired(e.target.checked)
  }

  const handleIsIncludeDeletedChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    setIsIncludeDeleted(e.target.checked)
  }

  return (
    <div className={cnTransactions('wrap')}>
      <Filter changeDate={date => setDate(date)} isVisibleSelect={false} />
      <div className={cnTransactions('checkboxes')}>
        <Checkbox
          checked={isIncludeExpired}
          onChange={handleIsIncludeExpiredChange}
          label={t('Expired')}
        />
        <Checkbox
          checked={isIncludeDeleted}
          onChange={handleIsIncludeDeletedChange}
          label={t('Deleted')}
        />
      </div>
      <Button
        isLoading={isLoadTransactions}
        xsmall
        className={cnTransactions('generate')}
        onClick={handleDownloadTransactions}
      >
        <i className='fa-solid fa-file-excel'></i>
        {t('Transactions')}
      </Button>
    </div>
  )
}

export default Transactions
